<template>
    <div class="catalog-tabs">
        <ul class="catalog-tabs__list">
            <li class="catalog-tabs__item" v-for="model in getSubCategories(null)">
                <label
                  class="label-radio"
                  :class="{ 'is-active': isActive(model.id)}"
                  :for="model.id"
                >
                    {{model.name}}
                    <input type="radio"
                           name="options"
                           v-bind:value="model.id"
                           v-bind:id="model.id"
                           v-model="active"
                    >
                </label>
                <ul class="catalog-tabs__middle" v-if="getSubCategories(model.id).length > 0">
                    <li class="catalog-tabs__item" v-for="model_l1 in getSubCategories(model.id)">
                        <label class="label-radio"
                               :class="{'is-active': isActive(model_l1.id) }"
                               :for="model_l1.id"
                        >
                            {{model_l1.name}}
                            <input type="radio"
                                   name="options"
                                   class="menu-top_link radiobutt"
                                   v-bind:value="model_l1.id"
                                   v-bind:id="model_l1.id"
                                   v-model="active"
                            >
                        </label>
                        <ul class="catalog-tabs__bottom" v-if="getSubCategories(model_l1.id).length > 0">
                            <li class="catalog-tabs__item" v-for="model_l2 in getSubCategories(model_l1.id)">
                                <label class="label-radio"
                                       :class="{'is-active': isActive(model_l2.id) }"
                                       :for="model_l2.id"
                                >
                                    {{model_l2.name}}
                                    <input type="radio"
                                           name="options"
                                           class="menu-top_link radiobutt"
                                           v-bind:value="model_l2.id"
                                           v-bind:id="model_l2.id"
                                           v-model="active"
                                    >
                                </label>
                            </li>
                        </ul>
                    </li>
                </ul>
            </li>
        </ul>
    </div>
</template>
<script>

    export default {
        props: ['categories', 'active_id'],
        computed: {
            active: {
                get: function () {
                    return this.active_id;
                },
                set: function (val) {
                    this.$emit('active-changed', val);
                    if(this.getSubCategories(val).length<1)
                    {
                        this.$emit('active-changed-last', val);
                    }
                }
            }
        },
        methods: {
            /**
             * Useful for nested blocks
             * @param parent_category_id
             * @returns {*}
             */
            getSubCategories: function (parent_category_id) {
                return this.sortCategories(this.categories.filter(item =>
                    item.show_in_menu === 1
                    && item.parent_id === parent_category_id
                ));
            },
            /**
             * Useful for separate blocks
             * @param level
             * @returns {*}
             */
            getCategoriesByLevel: function (level) {
                return this.sortCategories(this.categories.filter(item =>
                    item.show_in_menu === 1
                    && parseInt(item.level) === level
                    && this.isActive(item.parent_id)
                ));
                /*/
                // if no level attribute
                let category_id = null;
                while(level > 0){
                    let category = this.categories.find(item => item.parent_id === category_id && this.isActive(item.id));
                    if(!category){
                        return [];
                    }
                    category_id = category.id;
                    level--;
                }
                return this.sortCategories(this.categories.filter(item =>
                    item.show_in_menu === 1 &&
                    item.parent_id === category_id
                ));
                /**/
            },
            /**
             * Sort categories
             * @param categories
             * @returns {*}
             */
            sortCategories: function (categories) {
                return categories.sort((a, b) => a.sort - b.sort);
            },
            /**
             * Check is category active recursively
             * @param category_id
             * @returns {boolean}
             */
            isActive: function (category_id) {
                if (category_id === this.active) {
                    return true
                }
                let child_category = this.categories.find(item => item.parent_id === category_id && this.isActive(item.id));
                return typeof child_category !== "undefined";
            }
        }
    }

</script>


